import { Koi } from '@ksyos/koi';
import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { emailSchema } from '@common/validation/schemas';

export type OsasResendMijnKsyosQuestionnairesData = {
    patient: { emailAddress: string | null };
    resendQuestionnairesWeeks: number;
};

const osasResendMijnKsyosQuestionnairesDraft: TypedSchema<OsasResendMijnKsyosQuestionnairesData> = {
    patient: Koi.object({
        emailAddress: emailSchema.allow(null),
    }),
    resendQuestionnairesWeeks: Koi.number().integer().min(1).max(52).allow(null),
};

const osasResendMijnKsyosQuestionnairesFinal: TypedSchema<OsasResendMijnKsyosQuestionnairesData> = {
    patient: Koi.object({
        emailAddress: emailSchema,
    }),
    resendQuestionnairesWeeks: Koi.number().integer().min(1).max(52),
};

export type OsasResendMijnKsyosQuestionnairesReadKey = keyof OsasResendMijnKsyosQuestionnairesData;
export type OsasResendMijnKsyosQuestionnairesReadLabel = 'Herzend Ksyos vragenlijsten na' | 'E-mailadres patiënt';

export const osasResendMijnKsyosQuestionnairesReadSchema: TypedReadSchema<
    OsasResendMijnKsyosQuestionnairesReadKey,
    OsasResendMijnKsyosQuestionnairesReadLabel
>[] = [
    {
        items: [
            { key: 'patient', label: 'E-mailadres patiënt' },
            { key: 'resendQuestionnairesWeeks', label: 'Herzend Ksyos vragenlijsten na', type: 'dateAsString' },
        ],
    },
];

export const osasResendMijnKsyosQuestionnairesDraftSchema = Koi.object(osasResendMijnKsyosQuestionnairesDraft);
export const osasResendMijnKsyosQuestionnairesFinalSchema = Koi.object(osasResendMijnKsyosQuestionnairesFinal);
